module.exports = __webpack_public_path__ + "img/B270.bfa7700f.png";